import React from 'react';
import Main from './components/Main';
import { Box } from '@missionlabs/smartagent-app-components';

const App: React.FC = () => {
    const isEmbedded = window.parent !== window;

    return (
        <>
            {isEmbedded ? (
                <Main />
            ) : (
                <Box header="Billing Information" alt>
                    <Main />
                </Box>
            )}
        </>
    );
};

export default App;
